import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform {
    public transform(value: string): string {
        if (!value) {
            return '';
        }

        // Use libphonenumber to format the phone number if we have country code.
        if (value.startsWith('+') && parsePhoneNumber(value)) {
            const phoneNumber = parsePhoneNumber(value);
            const nationalFormat = phoneNumber.formatNational();
            return `+${phoneNumber.countryCallingCode} ${nationalFormat}`;
        }

        const parsedValue = value.replace(/\D/g, '');
        const array = parsedValue.split('');
        if (parsedValue.length > 10) {
            array.unshift('+');
        }
        if (parsedValue.length > 9) {
            array.splice(-10, 0, '(');
        }
        if (parsedValue.length > 7) {
            array.splice(-7, 0, ')');
        }
        if (parsedValue.length > 7) {
            array.splice(-7, 0, ' ');
        }
        if (parsedValue.length > 4) {
            array.splice(-4, 0, '-');
        }
        return array.join('');
    }
}
